/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
enum ChunkedStreamPlaybackMode {
    Live = 1,
    OndDemand = 2
}

export default ChunkedStreamPlaybackMode;